import { render } from "./GridNumberEditor.vue?vue&type=template&id=2b30cd50"
import script from "./GridNumberEditor.vue?vue&type=script&lang=js"
export * from "./GridNumberEditor.vue?vue&type=script&lang=js"

import "./GridNumberEditor.vue?vue&type=style&index=0&id=2b30cd50&lang=css"

import exportComponent from "/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__